"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragComponent = void 0;

var Point2D_1 = require("../../Core/Point2D");

var IRegionCallbacks_1 = require("../../Interface/IRegionCallbacks");

var RegionComponent_1 = require("./RegionComponent");
/**
 * An abstract visual component used internall do allow dragging the whole region.
 */


var DragComponent = /*#__PURE__*/function (_RegionComponent_1$Re) {
  _inherits(DragComponent, _RegionComponent_1$Re);

  /**
   * Creates a new `DragComponent` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function DragComponent(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, DragComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DragComponent).call(this, paper, paperRect, regionData, callbacks));
    /**
     * Dragging state of the component.
     */

    _this.isDragged = false;
    _this.node = paper.g();

    _this.node.addClass("dragLayer");

    return _this;
  }
  /**
   * Switches the component to the frozen state.
   */


  _createClass(DragComponent, [{
    key: "freeze",
    value: function freeze() {
      _get(_getPrototypeOf(DragComponent.prototype), "freeze", this).call(this);

      this.isDragged = false;
      this.dragOrigin = null;
    }
    /**
     * Helper function to subscibe the draggable element to events.
     */

  }, {
    key: "subscribeToDragEvents",
    value: function subscribeToDragEvents() {
      var _this2 = this;

      var listeners = [{
        event: "pointerenter",
        base: this.dragNode.node,
        listener: function listener(e) {
          if (_this2.isDragged) {
            e.stopPropagation();
          }
        },
        bypass: false
      }, {
        event: "pointermove",
        base: this.dragNode.node,
        listener: function listener(e) {
          if (_this2.isDragged) {
            var rect = e.target.getBoundingClientRect();
            var rdx = e.clientX - rect.left;
            var rdy = e.clientY - rect.top;
            var dx = e.clientX - _this2.dragOrigin.x;
            var dy = e.clientY - _this2.dragOrigin.y;

            if (rdx < 0 && dx > 0 || rdx > _this2.width && dx < 0) {
              dx = 0;
            }

            if (rdy < 0 && dy > 0 || rdy > _this2.height && dy < 0) {
              dy = 0;
            }

            var p = new Point2D_1.Point2D(_this2.x + dx, _this2.y + dy);

            if (_this2.paperRect !== null) {
              p = p.boundToRect(_this2.paperRect);
            }

            _this2.dragOrigin = new Point2D_1.Point2D(e.clientX, e.clientY);

            var rd = _this2.regionData.copy();

            rd.move(p);

            _this2.callbacks.onChange(_this2, rd, IRegionCallbacks_1.ChangeEventType.MOVING);
          }
        },
        bypass: false
      }, {
        event: "pointerleave",
        base: this.dragNode.node,
        listener: function listener(e) {// do nothing
        },
        bypass: false
      }, {
        event: "pointerdown",
        base: this.dragNode.node,
        listener: function listener(e) {
          _this2.dragNode.node.setPointerCapture(e.pointerId);

          var multiselection = e.ctrlKey;
          _this2.isDragged = true;
          _this2.dragOrigin = new Point2D_1.Point2D(e.clientX, e.clientY);

          _this2.callbacks.onManipulationLockRequest(_this2);

          _this2.callbacks.onChange(_this2, _this2.regionData.copy(), IRegionCallbacks_1.ChangeEventType.MOVEBEGIN, multiselection);
        },
        bypass: false
      }, {
        event: "pointerup",
        base: this.dragNode.node,
        listener: function listener(e) {
          _this2.dragNode.node.releasePointerCapture(e.pointerId);

          var multiselection = e.ctrlKey;

          if (_this2.isDragged) {
            _this2.callbacks.onChange(_this2, _this2.regionData.copy(), IRegionCallbacks_1.ChangeEventType.MOVEEND, multiselection);

            _this2.isDragged = false;
            _this2.dragOrigin = null;
          }

          _this2.callbacks.onManipulationLockRelease(_this2);

          _this2.callbacks.onChange(_this2, _this2.regionData.copy(), IRegionCallbacks_1.ChangeEventType.SELECTIONTOGGLE, multiselection);
        },
        bypass: false
      }];
      this.subscribeToEvents(listeners);
    }
  }]);

  return DragComponent;
}(RegionComponent_1.RegionComponent);

exports.DragComponent = DragComponent;